export default {
  root: {
    padding: '10px',
    color: '#66788A',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)'
    }
  }
};
